//引入外部模組
import {checkDevice} from '@/common';
import {BodyCtrl} from '@/body_ctrl';




//引入外部模組
let bodyCtrl = new BodyCtrl;




//Header 顯示 & 影藏
/*
class HeaderParallax {
  constructor() {
    this.body      = $('body');
    this.header    = $('header');
    this.container = $('#container>section, #container>div');
  }
  toggleActive(scrollTop, prev) {
    this.header.toggleClass('active', scrollTop > prev);
    if(scrollTop == 0 || scrollTop < 0){
      this.header.removeClass('active');
    }
  }
  showHide() {
    let prev = 0;
    $(window).on('scroll', (e) => {
      const $this   = $(e.currentTarget);
      let scrollTop = $this.scrollTop();
      if(scrollTop >= this.container.offset().top){
        this.toggleActive(scrollTop, prev);
        prev = scrollTop;
      }else{
        this.header.removeClass('active');
      }
      if(this.body.is('.scrollHide') || this.body.is('.scrollHideF')){
        this.header.removeClass('active');
        prev = scrollTop;
      }
    });
  }
}
*/




//Rwd 導航列 & 搜尋列
class NavSearch {
  constructor() {
    //搜尋列
    this.search          = $('#rwdSearch');
    this.searchOpen      = $('#rwdSearchOpen'); //手機板搜尋選單
    this.searchOpenHref  = $('#hrefSearchOpen');//電腦版搜尋選單
    this.searchClose     = $('#rwdSearchClose');
    this.searchTabs      = this.search.find('.tabs input:radio');
    this.selectBtn       = this.search.find('button');
    this.selectBox       = this.search.find('.selectBox');

    //追蹤列表
    this.track      = $('#rwdTrack');
    this.trackOpen  = $('#rwdTrackOpen');
    this.trackClose = $('#rwdTrackClose');

    //導航列
    this.nav       = $('#rwdNav');
    this.navOpen   = $('#rwdNavOpen');
    this.navClose  = $('#rwdNavClose');
    this.scrollBox = this.nav.find('.scrollBox');

    this.lightbox = $('#rwdLightbox');
  }
  action(el, open, close) {
    let removeRwd = () => {
      bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
      bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
      el.removeClass('active');
      this.lightbox.removeClass('active');
      this.selectBtn.removeClass('active');
      this.selectBox.removeClass('active');
    }
    open.on('click', () => {
      (checkDevice.ios || checkDevice.android)? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
      this.selectBtn.removeClass('active');
      this.scrollBox.scrollTop(0);
      this.selectBox.removeClass('active');
      this.lightbox.addClass('active');
      el.addClass('active');
    });
    this.lightbox.on('click', () => {
      removeRwd();
    });
    close.on('click', () => {
      removeRwd();
    });
  }
  hrefLocation(ahref) {
    ahref.on('click', () => {
      if( $('input[name=personalId]').val() !='') {
        location.href='./' + $('input[name=personalId]').val() + '?nav=buy';
      } else {
        location.href='./?nav=buy';
      }
    });
  }
  navSearch() {
    //搜尋列
    this.action(
      this.search,
      this.searchOpen,
      this.searchClose
    );
    //追蹤列表
    this.action(
      this.track,
      this.trackOpen,
      this.trackClose
    );
    //導航列
    this.action(
      this.nav,
      this.navOpen,
      this.navClose
    );
    //給值
    this.hrefLocation(
      this.searchOpenHref
    )
  }
}




//輸出
export {NavSearch};


// WEBPACK FOOTER //
// ./js_new/header.js